import React, { useState, useRef } from "react";
import { Client, Message } from "paho-mqtt";

const MQTT_URL = "wss://nwdl-dev-mqtt.h2osvc.biz/mqtt";
const MQTT_TOPIC = "GIOT-GW/DL/00005813d35ed916";
const MQTT_CLIENT_ID = "clientID-" + Math.floor(Math.random() * 1000);

const CODE_76 = JSON.stringify({
  dl_serial: "96C776C2",
  building_index: 1,
  floor_index: 2,
  room_index: 3,
  frame_number: 25,
  code: 76,
  data0: "01",
  data1: "0",
  data2: "",
  data3: "",
  data4: "",
});

const MqttDemo = () => {
  const [messages, setMessages] = useState([]);
  const [textarea, setTextarea] = useState("");
  const clientRef = useRef(null);
  const [connected, setConnected] = useState(false);

  const handleConnect = () => {
    if (clientRef.current) {
      clientRef.current.disconnect();
      setConnected(false);
    }
    const client = new Client(MQTT_URL, MQTT_CLIENT_ID);

    client.onConnectionLost = (response) => {
      setConnected(false);
      addMessage("연결이 끊어졌습니다: " + response.errorMessage, true);
    };

    client.onMessageArrived = (message) => {
      addMessage("RECEIVED: " + message.payloadString);
    };

    client.connect({
      userName: "admin",
      password: "admin",
      onSuccess: () => {
        setConnected(true);
        client.subscribe(MQTT_TOPIC);
        addMessage("MQTT 연결 성공!");
      },
      onFailure: () => {
        addMessage("MQTT 연결 실패!", true);
      },
      useSSL: false,
    });

    clientRef.current = client;
  };

  const addMessage = (msg, isError = false) => {
    setMessages((prev) => [
      { msg, isError, timestamp: new Date().toLocaleString() },
      ...prev,
    ]);
  };

  const handleSend = () => {
    if (!clientRef.current || !connected) {
      addMessage("연결 후에 메시지를 보낼 수 있습니다.", true);
      return;
    }

    // 입력값이 있으면 입력값, 아니면 CODE_76
    const payload = textarea.trim() ? textarea : CODE_76;

    const message = new Message(payload);
    message.destinationName = MQTT_TOPIC;
    clientRef.current.send(message);

    addMessage("SENT: " + payload);

    setTextarea("");
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>WebSocket MQTT Test (React)</h2>
      <textarea
        cols={60}
        rows={6}
        value={textarea}
        onChange={(e) => setTextarea(e.target.value)}
        style={{ fontSize: 24, verticalAlign: "bottom", width: "100%" }}
        placeholder="json 입력"
      />
      <br />
      <div className="card-foot">
        <div className="form-item-cancel">
          <button
            onClick={handleConnect}
            style={{
              background: "#0288d1",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              padding: "10px 36px",
              fontWeight: "bold",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            {connected ? "재연결" : "Connect"}
          </button>
        </div>
        <div className="form-item-add center">
          <button
            onClick={handleSend}
            style={{
              background: !connected ? "gray" : "#0288d1",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              padding: "10px 36px",
              fontWeight: "bold",
              fontSize: 16,
              cursor: !connected ? "not-allowed" : "pointer",
            }}
            disabled={!connected}
          >
            Send
          </button>
        </div>
      </div>
      <div
        id="output"
        style={{ marginTop: 20, maxHeight: 300, overflow: "auto" }}
      >
        {messages.map((m, i) => (
          <p key={i} style={{ color: m.isError ? "red" : "white" }}>
            [{m.timestamp}] {m.msg}
          </p>
        ))}
      </div>
    </div>
  );
};

export default MqttDemo;
